import React from 'react';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import _ from 'lodash';
import * as types from 'src/domains/query/types';
import AttrSelectorProvider, { Scope } from './AttrSelectorProvider';


const AttrSelectorProviderDialog: React.FC<{
    children: (props: Scope) => React.ReactElement,
    listConf: types.ListConf,
    anchorEl: Element | null,
    onClose: () => void,
    hidden: boolean
}> = ({
    children,
    listConf,
    anchorEl,
    onClose,
    hidden
}) => {
        return <Popover
            id={'columns-config-popover'}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <AttrSelectorProvider listConf={listConf} hidden={hidden}>
                {children}
            </AttrSelectorProvider>

            <Box textAlign='center'>
                <Button
                    onClick={onClose}
                    variant='contained'
                    sx={{ m: 1 }}
                    size='small'
                >
                    {'Ok'}
                </Button>
            </Box>
        </Popover>
    }

export default AttrSelectorProviderDialog;
